import { PickingProofEventItemType } from './PickingProofEventItemType'
import { FulfillmentIssueResolvedEventItemType } from './FulfillmentIssueResolvedEventItemType'

const EventItemType = ({ orderId, event }) => {
    if (event.type === 'PICKING_PROOF_ADDED') {
        return <PickingProofEventItemType orderId={orderId} event={event} />
    }

    if (event.type === 'FULFILLMENT_ISSUES_RESOLVED') {
        return <FulfillmentIssueResolvedEventItemType event={event} />
    }

    return event.type
}

export { EventItemType }
